import { atom } from 'recoil';

const alertAtom = atom({
  key: 'alertKey',
  default: false,
});

const errorAtom = atom({
  key: 'errorKey',
  default: false,
});

export { alertAtom, errorAtom };
